/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_TechniqueInputs */

const en_for_whom_tag_technique = /** @type {(inputs: For_Whom_Tag_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technique`)
};

const pl_for_whom_tag_technique = /** @type {(inputs: For_Whom_Tag_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technika`)
};

/**
* | output |
* | --- |
* | "Technique" |
*
* @param {For_Whom_Tag_TechniqueInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_technique = /** @type {((inputs?: For_Whom_Tag_TechniqueInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_TechniqueInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_technique(inputs)
	return en_for_whom_tag_technique(inputs)
});